import {ADD_APPLICATION_DATA} from "../constants/action-types";
require('es6-promise').polyfill();
require('fetch-everywhere');

const PAGE_DETAILS_URL = "/@product/api/v1/interactions/eq/users/0/applications/0/@action?page=@pageId&pageStatus=@pageStatus&interaction=eq";
const APPLICATION_DATA_URL = "/@product/api/v1/application/data";

export async function loadApplicationData(product) {
    return await fetch(APPLICATION_DATA_URL.replace('@product', product), {
        credentials: "same-origin", method: 'GET', headers: {
            'Cache-Control': 'no-cache',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    }).then(response => {
        return response.json().then((data) => {
            return ({type: ADD_APPLICATION_DATA, payload: data});
        }).catch((err) => {
            console.log("Error while getting app data.");
            return ({type: ADD_APPLICATION_DATA, payload: {}});
        })
    }).catch((err) => {
        console.log("Error while getting app data.");
        return ({type: ADD_APPLICATION_DATA, payload: {}});
    })
}

export function saveApplicationData(appData) {
    return ({type: ADD_APPLICATION_DATA, payload: appData});
}

export async function pageDetails(product, appData, action, pageId, pageStatus) {
    return await fetch(`${PAGE_DETAILS_URL.replace('@product', product)
        .replace('@action', action).replace('@pageId', pageId)
        .replace('@pageStatus', pageStatus)}`, {
        credentials: "same-origin", method: 'POST', body: JSON.stringify(appData), headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    }).then(response => {
        return response.json().then((data) => {
            return data["nextStep"];
        }).catch((err) => {
            console.log("Error while getting page details.");
            return [];
        })
    });
}
